module.exports = __webpack_public_path__ + "assets/img/ic-reload.b1833127.svg";